import type { z } from "zod/v4";
import type { DirEndpoint } from "./endpoint";
import type { DirQueryKey } from "./query";

function isDirQueryKey(value: unknown): value is DirQueryKey {
  return typeof value === "object" && value !== null && "feature" in value && value.feature === "dir";
}

export function invalidateQueriesFor(endpoint: DirEndpoint<z.ZodType>) {
  return {
    predicate: (query: { queryKey: readonly unknown[] }): boolean => {
      const key = query.queryKey[0];
      return isDirQueryKey(key) && key.resource === endpoint.resource;
    },
  };
}
